import script from "./ModalCrearComunidad.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCrearComunidad.vue?vue&type=script&setup=true&lang=js"

import "./ModalCrearComunidad.vue?vue&type=style&index=0&id=5c460252&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c460252"]])

export default __exports__